import { motion } from "framer-motion";

export const TruckSVG = ({ className = "" }) => (
  <svg viewBox="0 0 260 110" className={className}>
    <ellipse cx="130" cy="102" rx="115" ry="6" fill="#0A192F" opacity="0.12" />
    <rect x="18" y="60" width="150" height="10" rx="2" fill="#1F2937" />
    <rect x="24" y="22" width="138" height="38" rx="3" fill="#E5E7EB" stroke="#1A365D" strokeOpacity="0.25" />
    {[...Array(8)].map((_, i) => (
      <line key={i} x1={40 + i * 16} y1="22" x2={40 + i * 16} y2="60" stroke="#1A365D" strokeOpacity="0.14" strokeWidth="2.5" />
    ))}
    <rect x="24" y="50" width="138" height="5" fill="#EAB308" />
    <rect x="30" y="26" width="34" height="10" rx="2" fill="#0A192F" opacity="0.85" />
    <text x="47" y="34" textAnchor="middle" fill="#EAB308" fontSize="7" fontWeight="800" fontFamily="sans-serif">MANDAIR</text>
    <path d="M168 70 v-38 a6 6 0 0 1 6 -6 h34 a8 8 0 0 1 7 4 l16 24 a8 8 0 0 1 1 4 v12 z" fill="#0A192F" />
    <path d="M168 70 v-38 a6 6 0 0 1 6 -6 h34 a8 8 0 0 1 7 4 l16 24 a8 8 0 0 1 1 4 v12 z" fill="none" stroke="#EAB308" strokeOpacity="0.35" strokeWidth="1.5" />
    <path d="M179 32 h27 a6 6 0 0 1 5 3 l11 17 h-43 z" fill="#7DD3FC" opacity="0.9" />
    <rect x="232" y="60" width="16" height="9" rx="2" fill="#EAB308" />
    <rect x="236" y="52" width="6" height="6" rx="1" fill="#FDE68A" />
    <rect x="172" y="72" width="38" height="9" rx="3" fill="#9CA3AF" />
    <rect x="166" y="14" width="5" height="16" rx="2" fill="#6B7280" />
    <rect x="176" y="18" width="10" height="5" rx="2" fill="#EAB308" />
    <rect x="146" y="72" width="8" height="16" rx="1" fill="#111827" />
    <rect x="222" y="72" width="8" height="16" rx="1" fill="#111827" />
    {[
      [54, 78], [92, 78], [184, 78], [222, 78],
    ].map(([cx, cy]) => (
      <g key={cx}>
        <circle cx={cx} cy={cy} r="13" fill="#111827" />
        <circle cx={cx} cy={cy} r="5.5" fill="#9CA3AF" />
        <circle cx={cx} cy={cy} r="2" fill="#4B5563" />
      </g>
    ))}
  </svg>
);

export const TruckCameo = ({ from = "right", className = "" }) => (
  <motion.div
    aria-hidden="true"
    data-testid={`truck-cameo-${from}`}
    initial={{ x: from === "right" ? "45vw" : "-45vw", opacity: 0 }}
    whileInView={{ x: "0vw", opacity: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
    className={`pointer-events-none ${className}`}
  >
    <div style={from === "right" ? { transform: "scaleX(-1)" } : undefined}>
      <TruckSVG className="w-52 drop-shadow-2xl md:w-72" />
    </div>
  </motion.div>
);

export const TruckDriveBy = ({ direction = "ltr" }) => {
  const rtl = direction === "rtl";
  return (
    <div aria-hidden="true" data-testid={`truck-driveby-${direction}`} className="relative overflow-hidden border-y border-royal/10 bg-white py-5">
      <div className="absolute inset-x-0 bottom-7 border-t-2 border-dashed border-royal/15" />
      <motion.div
        initial={{ x: rtl ? "115vw" : "-25vw" }}
        animate={{ x: rtl ? "-25vw" : "115vw" }}
        transition={{ duration: 16, repeat: Infinity, ease: "linear" }}
        className="relative w-fit"
      >
        <div style={rtl ? { transform: "scaleX(-1)" } : undefined}>
          <TruckSVG className="w-36 drop-shadow-lg md:w-48" />
        </div>
      </motion.div>
    </div>
  );
};
